<script>
  export let contentsearch = false;
  export let courseSearch = false;
  export let vertical = false;
  

</script>


  {#if contentsearch}
  <div class="grid animate-pulse gap-3 grid-cols-1 md:grid-cols-[280px,auto] max-w-[1040px] ml-0 rounded-3xl md:w-screen mx-auto shadow-2xl">
    <div class="rounded-t-lg justify-self-start">
      <div
        class="rounded-3xl w-[280px] h-[280px] bg-pm-black"
      />
    </div>
    <div class="rounded-3xl">
      <div class="flex m-auto w-full p-5 flex-col">
        <p
          class="px-1 py-[.125rem] bg-pm-yellow/80 self-start w-[100px] h-4 rounded-full"
        >
        </p>
          <h3 class="text-4xl font-semibold my-4 bg-pm-black/30 w-1/2 h-7 rounded-full"></h3>
          <div class="text-2xl text-pm-black mb-5  bg-pm-black/70  h-7 rounded-full"></div>
          <div class="text-2xl text-pm-black mb-5 bg-pm-black/30 w-10/12 h-8 rounded-full">&emsp13;
          </div>
          <div class="text-2xl text-pm-black mb-5 bg-pm-pink h-7 w-1/3 rounded-full">
          </div>
      </div>
    </div>
  </div>
  {:else if courseSearch}
    {#if vertical} 
      <div class="rounded-3xl overflow-hidden shadow-card animate-pulse" style="width: 315px;">
        <div class="">
          <div class="grid grid-cols-1">
              <div class="relative">
                
                <div class="  bg-pm-black/80" style="width: 315px;height:150px"> </div>                
              </div>
              <div class="flex flex-col p-[15px]">
                <div class="text-2xl text-pm-black mb-5  bg-pm-black/70  h-7 rounded-full"></div>
                  <div class="text-2xl text-pm-black mb-5 bg-pm-black/30 w-10/12 h-8 rounded-full">&emsp13;
                  </div>
                  <div class="text-2xl text-pm-black mb-5 bg-pm-pink h-7 w-1/3 rounded-full">
                  </div>
              </div>
          </div>
        </div>
    </div>
    {:else}
      <div class="rounded-3xl mb-5 border border-pm-grey/10  shadow-course-card">

        <div class="flex m-auto w-full py-0 px-5 flex-col">
          <h3 class="text-4xl font-semibold my-4 bg-pm-black/80 w-3/4 h-7 rounded-full"></h3>
        <div class="grid grid-flow-col items-center content-center my-auto w-full">
          <div class="text-2xl text-pm-black mb-5 w-1/2 bg-pm-black/40  h-7 rounded-full"></div>
        </div>
        <div class="text-2xl text-pm-black mb-5 bg-pm-pink/60 h-7 w-1/3 rounded-full"></div>
        </div>
    </div>
    {/if}
  {/if}

  